import { Fragment } from "react";
import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { useDispatch, useSelector } from "react-redux";

import { sessionDataHandler } from "../sessionDataHandler";
import { changeEngagementPhase, updatePreEngagementData } from "../store/actions/genericActions";
import { EngagementPhase, AppState } from "../store/definitions";
import { containerStyles, textStyles, titleStyles } from "./styles/ConversationEnded.styles";
import type { Transcript } from "./Transcript";

export const ConversationEnded = () => {
  const dispatch = useDispatch();
  const { messages, users, preEngagementData, transcriptConfig } = useSelector((state: AppState) => ({
    messages: state.chat.messages,
    users: state.chat.users,
    preEngagementData: state.chat.conversation?.attributes.pre_engagement_data,
    transcriptConfig: state.config.transcript
  }));

  const handleStartNewChat = () => {
    sessionDataHandler.clear();
    dispatch(updatePreEngagementData({ email: "", name: "", query: "" }));
    dispatch(changeEngagementPhase({ phase: EngagementPhase.PreEngagementForm }));
  };

  let TranscriptComponent: typeof Transcript | undefined = undefined;

  // This file and its related dependencies are only bundled if transcripts are enabled in .env file
  if (process.env.DOWNLOAD_TRANSCRIPT_ENABLED === "true" || process.env.EMAIL_TRANSCRIPT_ENABLED === "true") {
    // eslint-disable-next-line @typescript-eslint/no-require-imports,@typescript-eslint/no-var-requires,global-require
    ({ Transcript: TranscriptComponent } = require("./Transcript"));
  }

  return (
    <Box {...containerStyles}>
      <Text as="h3" {...titleStyles}>
        Obrigado por conversar com o Cuidados Pela Vida
      </Text>
      {TranscriptComponent ? (
        <TranscriptComponent
          messages={messages}
          preEngagementData={preEngagementData}
          users={users}
          transcriptConfig={transcriptConfig}
        />
      ) : (
        <Fragment />
      )}
      <Text as="p" {...textStyles}>
        Se você tiver mais dúvidas, entre novamente no Chat.
      </Text>
      <button type="submit" style={{
        backgroundColor: "#FF5995",
        boxSizing: "border-box",
        width: "auto",
        appearance: "none",
        display: "inline-block",
        border: "none",
        outline: "none",
        transition: "background-color 100ms ease-in 0s, box-shadow 100ms ease-in 0s, color 100ms ease-in 0s",
        fontWeight: "600",
        textDecoration: "none",
        position: "relative",
        margin: "0px",
        cursor: "pointer",
        color: "white",
        padding: "0.5rem 0.75rem",
        borderRadius: "4px",
        fontSize: "0.875rem",
        lineHeight: "1.25rem"
      }} data-test="start-new-chat-button" onClick={handleStartNewChat}>
        Iniciar um novo Chat
      </button>
    </Box>
  );
};
